"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = _interopRequireDefault(require("../config"));
var _default = exports.default = function _default(domain) {
  var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config.default;
  if (!domain) {
    return null;
  }
  var cookieDomain = conf.nui.session.cookie.domain;
  if (cookieDomain && domain.indexOf(cookieDomain) !== -1) {
    return cookieDomain;
  }
  var domainParts = domain.split('.');
  if (domainParts.length === 1) {
    return null;
  }
  var len = domainParts.length === 2 ? 0 : 1;

  // eslint-disable-next-line no-control-regex,no-useless-escape
  return domain.match(/^(?=.*[^\.]$)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?){4}$/igm) ? null : ".".concat(domainParts.slice(len).join('.'));
};